import { convertObjectToSingleString, isEmpty } from '../../../../../utils/helper';
import { MENTION } from '../../../utils/editorStyles.constants';
export const mention = options => ({
  group: 'inline',
  inline: true,
  atom: true,
  selectable: false,
  draggable: false,
  attrs: {
    id: {
      default: ''
    },
    name: {
      default: ''
    },
    email: {
      default: ''
    },
    value: {
      default: ''
    },
    trigger: {
      default: ''
    }
  },
  toDOM: node => {
    const {
      trigger,
      id,
      email,
      value,
      name
    } = node.attrs;
    let currentTriggerOptions = {};
    let domAttrs = {
      class: 'tap-mentionnode',
      'data-id': id,
      'data-email': email,
      'data-name': name,
      'data-value': value,
      title: email,
      'data-trigger': trigger
    };
    if (trigger) {
      currentTriggerOptions = options.find(option => option.mentionTrigger === trigger) || {};
    } else if (email !== null && email !== void 0 && email.startsWith('{{')) {
      currentTriggerOptions = options.find(option => option.mentionTrigger === '{{');
    } else {
      currentTriggerOptions = options.find(option => option.mentionTrigger === '@');
    }
    if (currentTriggerOptions.hasInlineStyles) {
      domAttrs.style = convertObjectToSingleString(MENTION);
    }
    return ['span', domAttrs, getToDOMString(currentTriggerOptions.hidePrefixAndSuffix, currentTriggerOptions.renderAsHtml, currentTriggerOptions.suggestionsValues, name, email)];
  },
  parseDOM: [{
    tag: 'span.tap-mentionnode',
    getAttrs: dom => {
      const id = dom.getAttribute('data-id');
      const name = dom.getAttribute('data-name');
      const email = dom.getAttribute('data-email');
      const value = dom.getAttribute('data-value');
      const title = dom.getAttribute('title');
      const trigger = dom.getAttribute('data-trigger');
      return {
        id,
        name,
        email,
        value,
        title,
        trigger
      };
    }
  }]
});
const getToDOMString = (hidePrefixAndSuffix, renderAsHtml, suggestionsValues, name, email) => {
  if (renderAsHtml && !isEmpty(suggestionsValues) && suggestionsValues[email]) {
    return "".concat(suggestionsValues[email]);
  }
  if (hidePrefixAndSuffix) {
    return name || email;
  }
  return "@".concat(name) || email;
};